import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";

import CyberRiskFigure from "./components/CyberRiskFigure";
import firebase from "firebase/compat/app";

const Chapter7_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist das Ziel des Risikomanagements in der Cybersecurity?",
      options: [
        {
          value: "A",
          label:
            "Die Reduzierung von Wahrscheinlichkeit und Auswirkungen von Sicherheitsvorfällen.",
        },
        {
          value: "B",
          label: "Die vollständige Vermeidung aller Cyberbedrohungen.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Wie hilft das Risikomanagement in der Cybersecurity bei der Verteilung von Sicherheitsressourcen?",
      options: [
        {
          value: "A",
          label:
            "Es verteilt die Ressourcen gleichmäßig auf alle Sicherheitsrisiken, unabhängig von deren Priorität.",
        },
        {
          value: "B",
          label:
            "Es ermöglicht die Konzentration der Ressourcen auf die kritischsten Bedrohungen.",
        },
      ],
      correct: "B",
    },
  ];


  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 7_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
         
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "7_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("7_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 7_1.");
        } else {
         
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "7_1",
              completedChapters: ["7_1"],
            });
          console.log("Dokument erstellt mit Kapitel 7_1");
        }

        navigate("/cybersecurity/7_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  7. IT-Risikomanagement 
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Risikomanagement in der Cybersecurity
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 7: IT-Risikomanagement 
          </h3>
          <h2 className="text-center pb-5">
            Risikomanagement in der Cybersecurity{" "}
          </h2>
          <img
            src="/images/risikomanagement.webp"
            alt="Risikomanagement"
            style={{ position: "relative", maxWidth: "25%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Was ist Cybersecurity-Risikomanagement? </h2>
          <p className="col-lg-11 mx-auto">
            Das allgemeine Risikomanagement eines Unternehmens befasst sich mit
            einer Vielzahl von Risiken, die finanzielle, operative und
            strategische Ebenen umfassen. Ziel ist es, die
            Stabilität, Effizienz und Resilienz der Organisation zu
            gewährleisten, indem Risiken systematisch identifiziert, bewertet
            und gesteuert werden.       <br />
            <br />
            Das Cybersecurity-Risikomanagement, als spezialisierter Teilbereich,
            konzentriert sich auf digitale und IT-bezogene Bedrohungen.
            Es dient Unternehmen damit, gezielt Sicherheitsressourcen
            einzusetzen, Risiken zu priorisieren und eine proaktive Strategie
            zur Abwehr von Cybergefahren zu verfolgen. <br />
            <br />
            Lange Zeit wurde die Cybersecurity primär als technisches Problem
            angesehen, das in der Verantwortung der IT-Abteilung lag. Heute
            erkennt das Management, dass Cybersecurity ein
            unternehmerisches Risiko darstellt, das alle Bereiche eines
            Unternehmens betrifft. Dies hat dazu geführt, dass
            Cybersecurity-Risiken zunehmend in das allgemeine Risikomanagement
            integriert werden.
            <br />
            <br />
            Unternehmen, die Cyberrisiken
            systematisch in ihr Management einbinden, stärken ihre
            organisatorische Resilienz und finanzielle Stabilität. Durch diesen
            integrativen Ansatz sind sie besser in der Lage, fundierte
            Entscheidungen zu treffen, Bedrohungen frühzeitig zu erkennen und
            die Auswirkungen potenzieller Vorfälle zu minimieren. Dies trägt
            nicht nur zur Sicherung der Geschäftskontinuität bei, sondern
            fördert auch das Vertrauen von Kunden, Partnern und Investoren.
            <br />
            <br /> <br />
            <br />
<CyberRiskFigure />

            <br />
            <br />
          </p>
        </div>

        <div className="gelb-section">
          <div className="container p-5">
            <div className="p-5 ">
              <h3 className="p-5">Ziele des Cybersecurity-Risikomanagements</h3>
              <p className="col-lg-11 mx-auto">
                Ein gut durchdachtes Cybersecurity-Risikomanagement ermöglicht
                es Unternehmen, gezielt dort anzusetzen, wo die größten Gefahren
                lauern. Anstatt Sicherheitsmaßnahmen wahllos einzusetzen,
                schafft es Klarheit darüber, welche Risiken am dringendsten
                behandelt werden müssen. Dies sorgt nicht nur für mehr
                Sicherheit, sondern auch für eine effiziente Nutzung von
                Ressourcen.. <br />
                <br />
                <strong>Gezielte Maßnahmen durch Priorisierung: </strong> Unternehmen lernen,
                welche Bedrohungen die größten Auswirkungen haben könnten. Das
                Risikomanagement hilft dabei, Risiken zu bewerten, in eine Reihenfolge zu bringen und die
                kritischsten zuerst anzugehen. So können Sicherheitsressourcen
                gezielt eingesetzt werden.
                <br />
                <br />
                <strong>Effiziente Ressourcennutzung:</strong> Da nicht
                unbegrenzt Mittel und Personal zur Verfügung stehen, sorgt die
                Priorisierung dafür, dass vorhandene Ressourcen dort eingesetzt
                werden, wo sie den größten Unterschied machen. Dadurch wird
                sichergestellt, dass Sicherheitsmaßnahmen die maximale Wirkung
                erzielen.
                <br />
                <br />
                <strong>Schutz der Betriebsfähigkeit:</strong> Durch den Fokus auf die größten Risiken können Schwachstellen beseitigt
                werden, die die Aufrechterhaltung des Betriebs gefährden. Dies stellt sicher,
                dass das Unternehmen auch in schwierigen Situationen stabil
                bleibt und weiterarbeiten kann.
              </p>

              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                JPMorgan Chase erlebte 2014 einen Cyberangriff, bei dem die
                Daten von rund 76 Millionen Haushalten und 7 Millionen kleinen
                Unternehmen betroffen waren. Nach diesem Vorfall investierte die
                Bank massiv in ihre Cybersecurity-Infrastruktur und erhöhte ihr
                jährliches Budget für Cybersecurity auf über 600 Millionen
                US-Dollar. JPMorgan hat seitdem ein mehrstufiges
                Risikomanagement implementiert, das unter anderem regelmäßig
                Bedrohungsszenarien testet und strenge Zugriffsrichtlinien
                durchsetzt. Dank dieser Investitionen konnte die Bank das Risiko
                künftiger Angriffe erheblich reduzieren und die Auswirkungen
                potenzieller Vorfälle minimieren. (Forbes, 2014)
              </p>
            </div>
          </div>
        </div>
      </div>



      <div className="white-section">
        <div className="container ">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

            <h3 className="p-5">
              {" "}
              Erfolgreiches Cybersecurity-Risikomanagement am Beispiel der Bankenwelt
            </h3>

            <p className="col-lg-11 mx-auto">
              Einige Banken setzen neue Maßstäbe im
              Cybersecurity-Risikomanagement und übernehmen durch innovative
              Technologien, proaktive Strategien und umfassende
              Sicherheitsansätze eine Vorreiterrolle.
              <br />
              <br />
              <strong>Spitzenreiter in den USA: </strong>
              In den Vereinigten Staaten zählen PNC, Goldman Sachs und Discover
              Financial Services zu den führenden Institutionen im Bereich der
              Cybersecurity. Besonders herausragend ist die Flushing Bank, eine
              regionale Bank aus New York City, die den ersten Rang einnimmt.
              Ihre technischen Fähigkeiten und ihre fortschrittliche
              Sicherheitsinfrastruktur haben ihr eine Spitzenposition insbesondere im
              Bankensektor verschafft. (Forbes: Meet America’s Most Cybersecure Banks 2024 )<br />
              <br />
              <strong>Europäische Vorbilder: </strong>
              In Europa sticht die EuroFinance Bank in Frankfurt hervor. Durch
              den Einsatz KI-gestützter Sicherheitsplattformen hat sie
              Cyberangriffsversuche um beeindruckende 85 % reduziert. Ihre
              automatisierten Bedrohungserkennungssysteme gelten als führend in
              der Branche.
              <br />
              <br />
              Die Continental Bank in London konnte ebenfalls bedeutende Erfolge
              erzielen. Dank optimierter Prozesse konnte sie ihre
              Reaktionszeiten bei Vorfällen um 75 % beschleunigen und die Zahl
              erfolgreicher Cyberangriffe deutlich senken. <br />
              <br />
              <strong>Schlüssel zum Erfolg: </strong>
              <br />
              Diese Banken stechen hervor durch ihr ganzheitliches
              Management der Cybersecurity:
            </p>
            <p className="col-lg-9 text-start mx-auto">
              <ul>
                <li>
                  Integriertes Risikomanagement: Ein strukturierter Ansatz zur
                  Identifikation, Bewertung und Steuerungvon Risiken.
                </li>
                <li>
                  Modernste Technologien: Der Einsatz von{" "}
                  <Link to="/cybersecurity/4_3#zerotrust" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    Zero Trust Network Access
                  </Link>{" "}
                  und KI-gestützten Bedrohungserkennungssystemen.
                </li>
                <li>
                  Mitarbeiterschulungen: Regelmäßige Weiterbildungen zur
                  Sensibilisierung der Belegschaft für Cybergefahren.
                </li>
                <li>
                  Sicherheitsaudits: Kontinuierliche Überprüfung und Optimierung
                  der Sicherheitsmaßnahmen.
                </li>
                <li>
                  Engagement auf Vorstandsebene: Cybersecurity wird als
                  strategische Priorität angesehen, mit starker Unterstützung
                  und Steuerung durch die Führungsebene.
                </li>
              </ul>{" "}
            </p>

            <p className="col-lg-11 mx-auto">
              <small>
                (Forbes: Meet America’s Most Cybersecure Banks 2024 )
              </small>
            </p>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter7_1;
